/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import { Dialog } from '@tmna-ct/ipapps-core-js';
import styles from './styles';

class DialogServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  dialogResult = result => {
    alert(result ? 'User select: Ok' : 'User select: Cancel');
  };

  render() {
    const { classes } = this.props;
    const dialog = new Dialog();

    return (
      <div className={classes.container}>
        <br />
        <br />
        <h3>Testing for Browser Dialog/Alert:</h3>
        <br />
        <br />
        <p>
          Action to test JS Dialog standard functionalitie, tester should click the action then
          choose an option from the prompt open on screen.
        </p>
        <br />
        <Button
          variant="contained"
          onClick={() => this.dialogResult(dialog.decision('Testing a Decision dialog'))}
        >
          Decision Action
        </Button>
        <br />
        <br />
        <p>
          Action to test JS Alert standard functionalitie, tester should click the action then see
          the prompt open on screen.
        </p>
        <br />
        <Button variant="contained" onClick={() => dialog.notification('Testing message')}>
          Notification Message
        </Button>
      </div>
    );
  }
}

DialogServices.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DialogServices);
